// frontend/apps/widgets/src/widgets/GiftVoucher/components/NoVouchersDisplay.js
import React from 'react';
import PropTypes from 'prop-types';
import {Card, Typography, Box} from '@mui/material';
import GiftIcon from '@mui/icons-material/CardGiftcard';

const NoVoucherDisplay = ({t}) => {
  return (
    <Card
      role="status"
      aria-live="polite"
      sx={{
        textAlign: 'center',
        padding: '2rem',
        margin: '2rem 0',
        boxShadow: (theme) => theme.shadows[2],
        borderRadius: 2,
      }}
    >
      <Box>
        <GiftIcon aria-hidden="true" sx={{fontSize: 60, marginBottom: '1rem', color: 'primary.main'}} />
        <Typography variant="h5" gutterBottom>
          {t ? t('widgets.giftVoucher.noVouchers.title') : 'Aucun bon cadeau disponible'}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {t ? t('widgets.giftVoucher.noVouchers.message') : 'Ce commerce n\'a pas encore créé de bons cadeaux.'}
        </Typography>
      </Box>
    </Card>
  );
};

NoVoucherDisplay.propTypes = {
  t: PropTypes.func,
};

export default NoVoucherDisplay;
